<template>
    <div>

        <div v-show="!eidtRedirection">
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">宿舍房间管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>项目名称</span>
                            <el-select v-model="condition.project_id" placeholder="全部" style="width: 65%; margin-left: 10px;"
                                filterable>
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in projectList" :key="item.id" :label="item.project_name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>宿舍名称</span>
                            <el-input v-model="condition.dormitory_name" placeholder="请输入宿舍名称" style="width: 65%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="5">
                            <span>宿舍地址</span>
                            <el-input v-model="condition.dormitory_address" placeholder="请输入宿舍地址" style="width: 70%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>负责人姓名</span>
                            <el-select v-model="condition.staff_id" placeholder="请选择负责人" style="width: 58%; margin-left: 10px;"
                                filterable>
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in staffList" :key="item.id" :label="item.staff_name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>负责人电话</span>
                            <el-input v-model="condition.staff_phone" placeholder="请输入负责人电话" style="width: 60%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <!-- <el-col :span="3">
                            <el-input v-model="input" placeholder="请输入查询内容" style="width: 80%; margin-left: 10px;">
                            </el-input>
                        </el-col> -->

                    </el-row>

                    <el-row style="margin-top: 15px;">
                        <div style="float: right; margin-right: 30px;">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Find">
                                查询</el-button>
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Del">
                                删除</el-button>
                            <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">
                                新增</el-button>
                        </div>
                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="540"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="project_name" align="center" label="项目名称"></el-table-column>
                                <el-table-column prop="dormitory_name" align="center" label="宿舍名称"></el-table-column>
                                <el-table-column prop="dormitory_address" align="center" label="宿舍地址"></el-table-column>
                                <el-table-column prop="staff_name" align="center" label="负责人姓名"></el-table-column>
                                <el-table-column prop="staff_phone" align="center" label="负责人电话"></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/详情.png" @click="Edit(scope.row.id)" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <div>
            <el-dialog title="添加宿舍" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
                :center="true">
                <add ref="add"></add>
            </el-dialog>
            <FjGl ref="FjGl" v-show="eidtRedirection"></FjGl>
        </div>

    </div>
</template>

<script>
    import add from './SsfjGl_add.vue';
    import FjGl from './FjGl.vue';

    import axios from "axios";
    export default {
        components: {
            add: add,
            FjGl: FjGl,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,
                eidtRedirection: false,
                
                //项目下拉
                projectList: [],
                //人员下拉
                staffList: [],
                
                //条件
                condition: {
                    project_id: "",
                    dormitory_name: "",
                    dormitory_address: "",
                    staff_id: "",
                    staff_phone: "",
                },
                
                //详情id
                id: "",
                
                //复选框ids
                ids: [],
            };
        },
        methods: {
            //返回
            Return(e) {
                if (e === 'edit') {
                    this.id = "";
                    this.eidtRedirection = false;
                } else {
                    this.dialogVisible = false;
                }
                this.Find();
            },
            //列表点击复选框
            handleSelectionChange(e){
                this.ids = [];
                e.forEach(item => {
                    this.ids.push(item.id);
                })
            },
            //查询
            Find(){
                const url = this.$globals.http + "dormitory/find";
                axios.post(url, {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    project_id: this.condition.project_id,
                    dormitory_name: this.condition.dormitory_name,
                    dormitory_address: this.condition.dormitory_address,
                    staff_id: this.condition.staff_id,
                    staff_phone: this.condition.staff_phone,
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;
                    
                    if (code === '200') {
                        
                        this.tableData = data.list;
                        this.total = data.total;
                        
                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },
            //新增页面
            AddFrom() {
                this.dialogVisible = true;
            },
            //详情页面
            Edit(e) {
                this.id = e;
                this.eidtRedirection = true;
            },
            //删除
            Del(){
                if(this.ids === null || this.ids.length <= 0){
                    this.$message.warning("请先选择操作数据！");
                    return false;
                }
                
                const url = this.$globals.http + "dormitory/del";
                axios.post(url, {
                    ids: this.ids
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;
                    
                    if (code === '200') {
                        
                        this.$message.success(data);
                        this.Find();
                        
                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },
            //项目下拉查询
            ProjectSelectFind(){
                const url = this.$globals.http + "project/selectFind";
                axios.post(url, {
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;
                    
                    if (code === '200') {
                        
                        this.projectList = data;
                        
                    }
                }).catch((error) => {
                    console.log(error)
                })
            },
            //员工下拉查询
            StaffSelectFind(){
                const url = this.$globals.http + "staff/selectFind";
                axios.post(url, {
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;
                    
                    if (code === '200') {
                        
                        this.staffList = data;
                        
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }

        },
        created() {
            this.Find();
            this.ProjectSelectFind();
            this.StaffSelectFind();
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }
    
    >>>.el-checkbox__inner:hover{
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// SsfjGl.vue?e0b55e4e